/*
 * @Author: chenliang
 * @Date: 2020-11-27 10:37:55
 * @LastEditors: chenliang
 * @LastEditTime: 2021-02-25 22:16:10
 * @Description: file content
 */
const initialState = {
  getSystemCountPending: false,
  getSystemCountError: null,
  companyAll:0,
  companyToday:0,
  positionAll:0,
  positionToday:0,
  userAll:0,
  userToday:0,
  getHotByPositionTypePending: false,
  getHotByPositionTypeError: null,
  getHotByAreaPending: false,
  getHotByAreaError: null,
  getCountByPositionTypePending: false,
  getCountByPositionTypeError: null,
  hotByPositionType:[],
  countByPositionType:[],
  hotByArea:[],
  countByEduPending: false,
  countByEduError: null,
  countByAgePending: false,
  countByAgeError: null,
  countByGenderPending: false,
  countByGenderError: null,
  countByAge:[],
  countByEdu:[],
  countByGender:[],
  getSendPositionActionPending: false,
  getSendPositionActionError: null,
  sendPositionList:[],
  getBrowerActionPending: false,
  getBrowerActionError: null,
  userBrowerList:[],
  getPositionBrowerActionPending: false,
  getPositionBrowerActionError: null,
  positionBrowerList:[]
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/home/redux/initialState.js